import { render, staticRenderFns } from "./LoanCard.vue?vue&type=template&id=1652877b&scoped=true"
import script from "./LoanCard.vue?vue&type=script&lang=js"
export * from "./LoanCard.vue?vue&type=script&lang=js"
import style0 from "./LoanCard.vue?vue&type=style&index=0&id=1652877b&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1652877b",
  null
  
)

export default component.exports